export interface Testimonial {
  name: string;
  role: string;
  content: string;
  rating: number;
  avatar: string;
}

export const testimonials: Testimonial[] = [
  {
    name: 'Kevin',
    role: '资深gay片观众',
    content: '用了这个gay片导航站之后，找片效率提升太多了。以前总要在各个gay片平台之间反复对比，现在直接看推荐和评测，很快就能找到想看的gay片。分类整理也非常清晰，五星好评！',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20portrait%20on%20dark%20background%2C%20warm%20golden%20rim%20lighting%2C%20cinematic%20headshot%20with%20soft%20shadows%2C%20elegant%20editorial%20style&width=100&height=100&seq=avatar-1&orientation=squarish',
  },
  {
    name: 'Jason',
    role: 'gay片文化爱好者',
    content: '这个网站的gay片文章质量真的高！不只是简单的片单推荐，每篇gay片文章都很有深度，从文化背景到导演风格都有分析。看了几篇gay片深度文章之后，感觉自己对gay片的理解完全上升了一个层次。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Stylish%20male%20portrait%20with%20warm%20tone%20lighting%2C%20dark%20moody%20background%2C%20fashion%20editorial%20headshot%2C%20confident%20expression%2C%20professional%20photography&width=100&height=100&seq=avatar-2&orientation=squarish',
  },
  {
    name: 'Mike',
    role: 'gay片平台重度用户',
    content: '平台评测那块特别实用！之前一直纠结选哪个gay片平台，看了横向对比之后果断下单了推荐的gay片平台，确实没让我失望。安全指南那篇文章也帮了大忙，现在看gay片更安心了。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20male%20portrait%20with%20warm%20ambient%20light%2C%20dark%20studio%20background%2C%20professional%20headshot%20photography%2C%20friendly%20approachable%20expression&width=100&height=100&seq=avatar-3&orientation=squarish',
  },
  {
    name: 'Tony',
    role: '新入圈gay片观众',
    content: '作为刚入门的新人，这个gay片导航站简直是我的救命稻草！从gay片分类介绍到观看指南，每一步都有详细的指引。尤其是gay片品鉴入门那篇，让我从完全不懂到现在能看出gay片的好坏差别。',
    rating: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Young%20male%20portrait%20with%20soft%20warm%20lighting%2C%20dark%20muted%20background%2C%20modern%20editorial%20headshot%2C%20genuine%20smile%2C%20clean%20minimal%20aesthetic&width=100&height=100&seq=avatar-4&orientation=squarish',
  },
];